// extracted by mini-css-extract-plugin
export default {"scrollPath":"Scrollbar_scrollPath__UXLb0","progressbar":"Scrollbar_progressbar__UTVeP"};